export default "__VITE_ASSET__BFoiDvEW__"